import { render, staticRenderFns } from "./AjustarHorimetro.vue?vue&type=template&id=f5cc3010&scoped=true"
import script from "./AjustarHorimetro.vue?vue&type=script&lang=js"
export * from "./AjustarHorimetro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cc3010",
  null
  
)

export default component.exports